module.exports = __webpack_public_path__ + "img/edit.a7e99a4f.svg";